import React, { useState } from "react";
import {
  Typography,
  Collapse,
  IconButton,
  Card,
  CardContent,
  Box,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ScrollToTopButton from "./Utilities/ScrollToTopButton";
import { Helmet } from "react-helmet-async";

const faqs = [
  {
    question: "What is Copy Trading?",
    answer:
      "Copy Trading allows you to automatically replicate the trades of experienced traders in real-time, helping you participate in the market without actively managing trades yourself.",
  },
  {
    question: "Do I need to pay for copy trading?",
    answer:
      "Copy trading may involve performance fees or profit-sharing depending on the trader you follow. Some strategies may also be available without additional charges.",
  },
  {
    question: "Is copy trading available on your platform?",
    answer:
      "Yes, HC Finvest offers copy trading features that allow users to follow and copy selected traders directly through the platform.",
  },
  {
    question: "How do I start copy trading?",
    answer:
      "You can start by selecting a trader from the available list, reviewing their performance, and allocating funds to copy their trades.",
  },
  {
    question: "Can I stop copy trading at any time?",
    answer:
      "Yes, you have full control and can stop copying a trader or withdraw funds at any time.",
  },
  {
    question: "Is copy trading suitable for beginners?",
    answer:
      "Yes, copy trading is ideal for beginners as it allows them to learn from experienced traders while participating in the market.",
  },
  {
    question: "Can I choose how much to invest in copy trading?",
    answer:
      "Yes, you can decide the amount you want to allocate and manage your risk accordingly.",
  },
  {
    question: "Are profits guaranteed in copy trading?",
    answer:
      "No, profits are not guaranteed. Copy trading involves market risks, and performance depends on the trader you choose.",
  },
  {
    question: "Can I copy multiple traders at the same time?",
    answer:
      "Yes, you can diversify your investment by copying multiple traders simultaneously.",
  },
  {
    question: "How do I select the right trader to copy?",
    answer:
      "You should review factors like trading history, risk level, consistency, and overall performance before selecting a trader.",
  },
];

const CopyTradingfaq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
      <>
      <Helmet>
        <link rel="canonical" href="https://www.hcfinvest.com/copyTradingfaq" />
      </Helmet>
              <Container sx={{ backgroundColor: "#fff" }} maxWidth={false} disableGutters>
        <ScrollToTopButton/>
      <Box
        sx={{
          position: "relative",
          height: "475px",
          display: "flex",
          flexDirection: "column", // 👈 Stack text vertically
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          backgroundImage: `url('Images/HelpCenterImages/Newhedgecapitalsimage_Helpcenter 1.jpg')`, // 👈 replace with your image path
          backgroundSize: "cover",
          backgroundPosition: "center",
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        <h1
          variant="h3"
          component="h1"
          sx={{
            zIndex: 2,
            fontWeight: 600,
            textAlign: "center",
            px: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Trade Like a Pro, Even
        </h1>

        <h1
          variant="h3"
          component="h1"
          sx={{
            zIndex: 2,
            fontWeight: 600,
            textAlign: "center",
            px: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          if You're Just Starting Out
        </h1>

        <h3
          variant="h5"
          sx={{
            zIndex: 2,
            fontWeight: 600,
            textAlign: "center",
            px: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Amplify Your Trading Success with HC Finvest Copy Trading
        </h3>
      </Box>

      <Typography
        variant="h2"
        sx={{
          marginBottom: "50px",
          fontWeight: "600",
          fontSize: "2.5rem",
          color: "#101828",
        }}
      >
        FAQ
      </Typography>

      <Box sx={{ maxWidth: "1200px", margin: "40px auto" }}>
        {faqs.map((faq, index) => (
          <Card
            key={index}
            sx={{
              mb: 2,
              boxShadow: 2,
              borderRadius: 2,
              backgroundColor: "#fff",
              cursor: "pointer",
            }}
            onClick={() => handleToggle(index)}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" fontWeight="bold">
                  {faq.question}
                </Typography>
                <IconButton>
                  <ExpandMoreIcon
                    sx={{
                      transform:
                        openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </IconButton>
              </Box>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Typography
                  variant="body1"
                  sx={{
                    mt: 2,
                    color: "text.secondary",
                    lineHeight: 1.7,
                    textAlign: "left",
                  }}
                >
                  {faq.answer}
                </Typography>
              </Collapse>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Container>
      
      </>
  );
};

export default CopyTradingfaq;
